<template>
<div class="view">
  <decorate></decorate>
  <div class="main record_page">
    <div class="nav">
      <div class="left">
        <router-link class="front icon_back" :to="{path:'/' , query : queryData }"></router-link>
      </div>确认提现信息
    </div>
    <Scrapper class="scroll" ref="view">
      <div class="check_page">
        <div class="bank_check active" v-for="(item , index) in homePage.bankList" :key="index">
          <div style="display: flex;" @click="confirmAli(item)">
            <div v-if="select == item.id" class="left choose_left"></div>
            <div v-else class="left"></div>
            <div class="right">
              <p class="p">收款人姓名：{{item.name}}</p>
              <p class="p">电话号码：{{item.phone}}</p>
              <p class="p">银行卡号码：{{item.number}}</p>
              <p class="p">银行名称：{{item.bank_name}}</p>
              <p class="p">开户地址：{{item.bank}}</p>
            </div>
            <div v-if="Syssetting[1][0].value == 3">
              <img class="img-icon" src="../assets/images/stop-icon.png" alt />
            </div>
          </div>
        </div>
        <div class="bank_check active" v-for="(item , index) in homePage.AlipayList" :key="index">
          <div style="display: flex;" @click="confirmAli(item)">
            <div v-if="select == item.id" class="left choose_left"></div>
            <div v-else class="left"></div>
            <div class="right">
              <p class="p">支付宝姓名：{{item.alipay_name}}</p>
              <p class="p">支付宝账号：{{item.number}}</p>
            </div>
            <div v-if="Syssetting[1][0].value == 2">
              <img class="img-icon" src="../assets/images/stop-icon.png" alt />
            </div>
          </div>
        </div>
        <div class="submit" @click="acquireAddas()">提交</div>
      </div>
    </Scrapper>
  </div>
  </div>
</template>
<script>
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import Vue from "vue";
import { Field, Area, Icon } from "vant";
import Scrapper from "./element/Scrapper";
import decorate from "./element/decorate";
import "../css/aside.scss";
Vue.use(Field).use(Area).use(Icon);
export default {
  components: { Scrapper ,decorate},
  data: function () {
    return {
      bankId: "",
      alipayId: "",
      topHeight: 0,
      active: "",
      // active1 : 1 ,
    };
  },
  computed: {
    ...mapState(["homePage"]),
    ...mapState("homePage", ["Syssetting", "sletId", "sletId2", "select"]),
  },
  watch: {},
  created() {
    console.log(this.Syssetting);
    this.queryData = this.$route.query || {};
    this.topHeight = this.queryData.TopHeight;
    let obj = {
      userId: this.queryData.userId,
      appId: this.queryData.appId,
      uid: this.queryData.uid,
    };
    this.$store.dispatch("homePage/fetchBankList", obj);
    this.$store.dispatch("homePage/fetchAlipayList", obj);
  },
  methods: {
    ...mapActions(["fetchHome"]),
    ...mapMutations("homePage", ["setsletId", "setsletId2", "setselect"]),

    // //设置默认银行卡
    // //设置默认支付宝
    confirmAli(item) {
      if (item.bank) {
        if(this.Syssetting[1][0].value == 1 || this.Syssetting[1][0].value == 2){
          this.setselect(item.id);
          // console.log(this.select)
        } else {
          this.$dialog({
            title: "提醒",
            message: "银卡提现渠道暂停使用请选择或增加支付宝进行提现操作",
          });
        }
      }
      if (item.alipay_name) {
                if (this.Syssetting[1][0].value == 1 || this.Syssetting[1][0].value == 3) {
        this.setselect(item.id);
        // console.log(this.select)
      } else {
          this.$dialog({
              title: '提醒',
              message: '支付宝提现渠道暂停使用请选择或增加银行卡进行提现操作'
          })
      }
      }
    },
    //提取收货id跳转到首页领取奖品
    acquireAddas() {
      // if (this.Syssetting[1][0].value == 1) {
      let obj = {
        userId: this.queryData.userId,
        appId: this.queryData.appId,
        uid: this.queryData.uid,
      };
      this.$store.dispatch("homePage/fetchBankList", obj).then((res) => {
        let data = res.data;
        // let state = false
        for (let k in data) {
          // if (data[k].is_default == 1) {
          // state = true
          this.bankId = data[k].id;

          // }
        }
      });
      this.$store.dispatch("homePage/fetchAlipayList", obj).then((res) => {
        let data = res.data;
        // let state = false
        for (let k in data) {
          // if (data[k].is_default == 1) {
          // state = true
          this.alipayId = data[k].id;
          // }
        }
      });
      setTimeout(() => {
        if ((this.select = this.bankId)) {
          this.$router.push({
            path: "/",
            query: {
              // alipayId: this.select,
              bankId: this.select,
              userId: this.queryData.userId,
              appId: this.queryData.appId,
              uid: this.queryData.uid,
              apptype: this.queryData.apptype,
              TopHeight: this.queryData.TopHeight,
            },
          });
        }
        if ((this.select = this.alipayId)) {
          this.$router.push({
            path: "/",
            query: {
              alipayId: this.select,
              // bankId: this.select,
              userId: this.queryData.userId,
              appId: this.queryData.appId,
              uid: this.queryData.uid,
              apptype: this.queryData.apptype,
              TopHeight: this.queryData.TopHeight,
            },
          });
        }
      }, 1000);
      // }
      // }
    },
  },

  mounted() {
    // const self=this;
    // this.$refs.view.scroll.on('scroll',(position)=>{
    //     self.$parent.scrollY=position.y;
    // })
  },
};
</script>